import { useTranslation } from "../../i18n/LanguageContext";
import { ICONS } from "../../i18n/translations";

export default function WhyUs() {
  const { t } = useTranslation();
  const w = t.why;
  return (
    <section
      data-testid="why-us-section"
      className="relative py-16 md:py-32 bg-[#dfd3ee]"
    >
      <div aria-hidden className="pointer-events-none absolute inset-x-0 bottom-0 h-16 md:h-24 bg-gradient-to-b from-transparent to-[#ebe2f5]" />
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-10 lg:gap-20">
          <div className="lg:sticky lg:top-32 self-start">
            <p className="text-eyebrow">{w.eyebrow}</p>
            <h2 className="mt-4 sm:mt-5 font-serif-display text-[34px] leading-[1.1] sm:text-4xl md:text-5xl lg:text-6xl text-[#0a0a0a]">
              {w.titleA}{" "}
              <span className="italic gold-text">{w.titleB}</span>
            </h2>
            <div className="gold-line mt-8" />
            <p className="mt-8 text-[#8a7f8f] leading-relaxed max-w-md">
              {w.intro}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {w.items.map((item, i) => {
              const Icon = ICONS.WHY_ICONS[i % ICONS.WHY_ICONS.length];
              return (
                <div
                  key={i}
                  data-testid={`why-us-item-${i}`}
                  className="group p-7 rounded-3xl bg-[#f5effb] border border-white/5 hover:border-[#0a0a0a]/30 transition-all duration-500 hover:-translate-y-1"
                >
                  <span className="w-12 h-12 rounded-2xl flex items-center justify-center border border-[#0a0a0a]/25 bg-[#0a0a0a]/5 group-hover:bg-[#0a0a0a]/10 transition-colors">
                    <Icon
                      size={20}
                      strokeWidth={1.4}
                      className="text-[#0a0a0a]"
                    />
                  </span>
                  <h3 className="mt-5 font-serif-display text-xl text-[#1a1a1a] leading-tight">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm text-[#594f5a] leading-relaxed">
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
